import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { breakpoints } from 'globalStyles'

// Mapping FontAwesome size strings to equivalent pixel values
const sizeMap = {
  '2xs': '10',
  xs: '12',
  sm: '14',
  lg: '20',
  xl: '24',
  '2xl': '32',
}

const StyledSVG = styled.svg`
  display: inline-block;
  vertical-align: middle;

  ${(props) =>
    props.onClick &&
    css`
      cursor: pointer;
    `}

  ${(props) =>
    props.$respSize.phone &&
    css`
      @media only screen and ${breakpoints.phone} {
        width: ${props.$respSize.phone.size};
        height: ${props.$respSize.phone.size};
      }
    `}

  ${(props) =>
    props.$respSize.tablet &&
    css`
      @media only screen and ${breakpoints.tablet} {
        width: ${props.$respSize.tablet.size};
        height: ${props.$respSize.tablet.size};
      }
    `}

  ${(props) =>
    props.$respSize.desktop &&
    css`
      @media only screen and ${breakpoints.lg_above} {
        width: ${props.$respSize.desktop.size};
        height: ${props.$respSize.desktop.size};
      }
    `}
`

const SVGIcon = ({ Icon, color, size, respSize, style, onClick }) => {
  const fontSize = sizeMap[size] || sizeMap.xl

  const viewBox = Icon?.props?.viewBox || '0 0 24 24' // Default viewBox
  const [, , width, height] = viewBox.split(' ').map(Number)
  const aspectRatio = width / height

  const calculatedWidth = fontSize * aspectRatio
  const calculatedHeight = fontSize
  return (
    <StyledSVG
      as={Icon}
      fill={color}
      $respSize={respSize}
      style={{
        ...style,
        color, // Allow parent styles to override color
      }}
      onClick={onClick}
      width={`${calculatedWidth}px`}
      height={`${calculatedHeight}px`}
    />
  )
}

const viewSizeProps = PropTypes.shape({
  size: PropTypes.string.isRequired,
})

const respSizePropTypes = {
  phone: viewSizeProps,
  tablet: viewSizeProps,
  desktop: viewSizeProps,
}

export const svgIconsPropTypes = {
  Icon: PropTypes.elementType.isRequired,
  color: PropTypes.string,
  size: PropTypes.string,
  respSize: PropTypes.shape(respSizePropTypes),
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.shape({})]),
  onClick: PropTypes.func,
}

SVGIcon.propTypes = svgIconsPropTypes

SVGIcon.defaultProps = {
  color: null,
  size: 'xl', // Default size
  respSize: {
    phone: null,
    tablet: null,
    desktop: null,
  },
  style: {},
  onClick: undefined,
}

export default SVGIcon
